export default [
  {
    path: 'customer',
    component: () => import('@/views/customer/Customer'),
    meta: { title: '客户查询', componentName: 'Customer' },
    children: [
      {
        path: 'add',
        component: () => import('@/views/customer/CustomerAddForm'),
        props: true,
        meta: { title: '新建客户' }
      },
      {
        path: 'detail/:id',
        component: () => import('@/views/customer/CustomerDetail'),
        props: true,
        meta: { title: '客户详情' }
      }
    ]
  },
  {
    path: 'customer_visit',
    component: () => import('@/views/customer/CustomerVisit'),
    meta: { title: '回访记录' }
  },
  {
    path: 'customer_complain',
    component: () => import('@/views/customer/CustomerComplain'),
    meta: { title: '投诉处理' }
  },
  {
    path: 'customer_delivery',
    component: () => import('@/views/customer/CustomerDelivery'),
    meta: { title: '上门服务' }
  },
  {
    path: 'customer_gift',
    component: () => import('@/views/customer/CustomerGift'),
    meta: { title: '礼物管理', componentName: 'CustomerGift' }
  },
  {
    path: 'entry/record',
    component: () => import('@/views/customer/EntryRecord'),
    meta: { title: '进场记录' },
    children: [
      {
        path: 'detail/:id',
        component: () => import('@/views/customer/EntryRecordDetail'),
        props: true,
        children: [
          {
            path: 'track/:customerId/:vehicleId',
            component: () => import('@/views/home/TrackList'),
            props: true,
            meta: { title: '跟踪记录' }
          }
        ]
      }
    ]
  },
  {
    path: 'gift_delivery',
    component: () => import('@/views/customer/CustomerGift'),
    props: () => ({ delivery: true }),
    meta: { title: '礼物配送', componentName: 'CustomerGift' }
  },
  {
    path: 'customer_care',
    component: () => import('@/views/customer/CustomerCare'),
    props: () => ({ delivery: true }),
    meta: { title: '客户关怀' }
  },
  {
    path: 'customer_service',
    component: () => import('@/views/customer/Customer'),
    props: () => ({ isService: true }),
    meta: { title: '客户列表', componentName: 'Customer' },
    children: [
      {
        path: 'detail/:id',
        component: () => import('@/views/customer/CustomerDetail'),
        props: route => ({
          id: route.params.id,
          isService: true
        }),
        meta: { title: '客户详情' }
      }
    ]
  }
]
